const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_CHARACTERS = /^[0-9()+\-.\s]+$/;

export function isBlank(value: unknown): boolean {
  return value === undefined || value === null || String(value).trim() === '';
}

export function isValidEmail(value: unknown): boolean {
  return EMAIL_PATTERN.test(String(value ?? '').trim());
}

/** Blank, or a mask with nothing typed into it yet, e.g. "(___)___-____". */
export function isEmptyPhone(value: unknown): boolean {
  return isBlank(value) || /^[()\-\s_]*$/.test(String(value));
}

/** 7–15 digits using only digits, spaces and ()+-. ; a value still holding the mask placeholder is partly typed. */
export function isValidPhone(value: string): boolean {
  const digits = value.replace(/\D/g, '').length;
  return !value.includes('_') && PHONE_CHARACTERS.test(value) && digits >= 7 && digits <= 15;
}
